module.exports = __webpack_public_path__ + "media/assets/images/flags/ca-ab17266e29be08f28a43a61ad22f5390.svg";